import {
	type FetchInput,
	type FetchResponse,
	getTraceId,
} from '@atlassian/expansion-services/services';

import { cfetch } from '@confluence/network';

export const cfetchJSON = async <Response,>(
	input: FetchInput,
): Promise<FetchResponse<Response>> => {
	const { url, ...options } = input;

	try {
		const response = await cfetch(url, options);
		if (response.ok) {
			const data = (await response.json()) as Response;
			const traceId = getTraceId(response);
			return { data, traceId };
		} else {
			throw new Error(`Fetch failed with status ${response.status}`);
		}
	} catch (error) {
		if (error instanceof Error) {
			error.message = `Error while fetching: ${error.message}`;
		}
		throw error;
	}
};
